var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"quillEditor",staticClass:"editor",class:{
    'is-focused': _vm.editorFocused,
  },attrs:{"value":_vm.value,"options":_vm.options},on:{"change":_vm.onEditorChange,"ready":function($event){_vm.onEditorReady($event)},"blur":function($event){_vm.onEditorBlur($event)},"focus":function($event){_vm.onEditorFocus($event)}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a16e846","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/QuillEditor.vue
// module id = DGLm
// module chunks = 1